import '.gr{position:sticky;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.ac{flex-direction:column;}.ssr-plugin'
import '.fa{gap:6px;}.ssr-plugin'
import '.dj{top:0px;}.ssr-plugin'
import '.gs{padding:8px 8px 0px 8px;}.ssr-plugin'
import '.dt{z-index:1;}.ssr-plugin'
import '.fk{padding:8px;}.ssr-plugin'
import '.eo{gap:2px;}.ssr-plugin'
import '.aw{bottom:0px;}.ssr-plugin'
import '.gt{padding:0px 8px 8px 8px;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import { ReactNode, useState } from 'react'
import { IconProps } from '../Icon/index.js'
import { Menu } from '../Menu/index.js'
import { TextInput } from '../TextInput/index.js'
import { Separator } from '../Separator/index.js'
import { Dropdown } from '../Dropdown/index.js'
import { Style } from 'inlines'
import { styled } from 'inlines'
import { colors } from '../../tokens/colors.js'
import { LabelDescription } from '../LabelDescription/index.js'

type SelectInputOption = {
  value: string | number | boolean
  label: string | ReactNode
  labelFilterText?: string
}

type SelectInputProps = {
  value?: string | number | boolean
  onChange: (value: string | number | boolean) => void
  leadIcon?: IconProps['variant']
  error?: boolean
  disabled?: boolean
  placeholder?: string
  options: SelectInputOption[]
  filterable?: boolean
  unclearable?: boolean
  style?: Style
  label?: string
  description?: string
  errorMessage?: string
  ghost?: boolean
}

let fixedValue: string = ''

const SelectInput = ({
  disabled,
  error,
  leadIcon,
  options,
  value,
  onChange,
  placeholder,
  filterable,
  unclearable = true,
  style,
  label,
  description,
  errorMessage,
  ghost,
}: SelectInputProps) => {
  const [filter, setFilter] = useState<string>()
  const [open, setOpen] = useState(false)

  const shouldBeFilterable =
    options.length > 5 ? filterable !== false : filterable

  if (typeof value === 'string' && !fixedValue) {
    fixedValue = value
  }

  const filteredOptions = options.filter((option) => {
    if (filter && option.labelFilterText) {
      return option.labelFilterText
        .toLowerCase()
        .includes(filter.toLocaleLowerCase())
    }
    if (filter && typeof option.label === 'string') {
      return option.label.toLowerCase().includes(filter.toLocaleLowerCase())
    }
    return true
  })

  return (
    <LabelDescription
      label={label}
      description={description}
      error={error && errorMessage}
    >
      <Menu
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        autoScroll
      >
        <Menu.Trigger>
          <Dropdown
            onClick={() => {
              setFilter('')
            }}
            ghost={ghost}
            open={open}
            error={error}
            leadIcon={leadIcon}
            disabled={disabled}
            placeholder={placeholder}
            value={
              filteredOptions.find((option) => option.value === value)?.label
            }
            style={style}
          />
        </Menu.Trigger>
        <Menu.Items
          autoScroll
          style={{
            padding: 0,
          }}
        >
          {shouldBeFilterable && (
            <div className="gr a ac fa dj gs dt"
              style={{
                left: -8,
                right: -8,
                background: `linear-gradient(${colors.neutral10Background}),
                linear-gradient(${colors.neutralInverted100})`,}}
            >
              <TextInput
                value={filter}
                onChange={(value) => {
                  setFilter(value)
                }}
                variant="ghost"
                leadIcon="search"
                placeholder="Find..."
              />
              <Separator style={{ padding: 0, height: 1 }} />
            </div>
          )}
          <div className="fk"
          >
            {filteredOptions.map((option, idx) => (
              <Menu.Item
                key={option.value?.toString()}
                keepOpenOnClick={false}
                selected={option.value === value || value === idx}
                indentContent={option.value !== value && value !== idx}
                onClick={() => {
                  if (option.value === value && !unclearable) {
                    onChange(null)
                  } else {
                    onChange(option.value)
                  }
                }}
              >
                {option.label}
              </Menu.Item>
            ))}
            {filteredOptions.length === 0 && filter && (
              <Menu.Item
                label="No results"
                indentContent
                disabled
                style={{ pointerEvents: 'none' }}
              />
            )}
          </div>
          {!unclearable && !filter && (
            <div className="gr a ac eo aw gt f dt"
              style={{
                left: -8,
                right: -8,
                background: `linear-gradient(${colors.neutral10Background}),
                linear-gradient(${colors.neutralInverted100})`,}}
            >
              <Separator style={{ padding: 0, height: 1 }} />
              <Menu.Item
                label="Clear"
                color="red"
                leadIcon="close"
                onClick={() => onChange(null)}
                style={{ width: '100%', marginTop: 6 }}
              />
            </div>
          )}
        </Menu.Items>
      </Menu>
    </LabelDescription>
  )
}

export { SelectInput }
export type { SelectInputProps }
